import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const contactSupportSchema = z.object({
  subject: z.string().min(1, 'Subject is required'),
  details: z.string().min(1, 'Details are required'),
});

export type ContactSupportFormValues = z.infer<typeof contactSupportSchema>;

export const defaultValues: ContactSupportFormValues = {
  subject: '',
  details: '',
};

function useContactSupportForm() {
  const schema = useMemo(() => contactSupportSchema, []);

  return useForm<ContactSupportFormValues>({
    defaultValues,
    resolver: zodResolver(schema),
  });
}

export default useContactSupportForm;
